import { getResourceName } from "../utils/resourceName";
import { usePropAsState } from "./usePropAsState";
import { DEFAULT_PREVIEW, Preview, UpdatePreview, useMetaPreview } from "./useMetaPreview";
import { ResourceInfoDc } from "../modules/Catalog/types";

export interface ResourceMeta {
  alias?: string;
  description?: string;
  preview?: Preview;
  copyrightText?: string;
  name?: string;
}

export interface ResourceMetaUpdate {
  setAlias: (alias: string) => void;
  setDescription: (description: string) => void;
  setCopyrightText: (copyrightText: string) => void;
  setName: (name: string) => void;
  setPreview: UpdatePreview;
}

export const DEFAULT_META = {
  alias: "",
  description: "",
  preview: DEFAULT_PREVIEW,
  copyrightText: "",
};

export const useResourceMeta = (resourceMeta: ResourceMeta): [ResourceMeta, ResourceMetaUpdate] => {
  const [alias, setAlias] = usePropAsState(resourceMeta.alias, DEFAULT_META.alias);
  const [description, setDescription] = usePropAsState(resourceMeta.description, DEFAULT_META.description);
  const [preview, setPreview] = useMetaPreview(resourceMeta.preview);
  const [copyrightText, setCopyrightText] = usePropAsState(resourceMeta.copyrightText, DEFAULT_META.copyrightText);
  const [name, setName] = usePropAsState(resourceMeta.name, getResourceName());

  return [
    { alias, description, preview, copyrightText, name },
    { setAlias, setDescription, setPreview, setCopyrightText, setName },
  ];
};

export const getMetaFromResource = (resource?: ResourceInfoDc, previewUrl?: string): ResourceMeta => {
  if (resource && resource.preview !== undefined) {
    const { alias, description, preview, name } = resource;

    return {
      alias: alias || DEFAULT_META.alias,
      description: description || DEFAULT_META.description,
      preview: {
        resourcePreview: preview,
        src: resource.preview ? previewUrl : "",
        file: null,
      },
      name,
    };
  }

  return DEFAULT_META;
};
